var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Intro'),_c('News'),_c('About'),_c('Gallary'),_c('Cultures'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }